import { roles, SERVICES } from "../../configs/constants";

export default {
  display: true,
  title: "Import",
  contentType: "menu",
  canReduce: true,
  search: false,
  content: [
    {
      label: "Référentiel Métier",
      icon: "import",
      id: "metier",
      component: "",
      path: "/imports/metier",
      onClick: "",
      submenu: false,
      minRole: 1
    },
    {
      label: "Modèles MEA/PLV",
      icon: "import",
      id: "merch",
      component: "",
      path: "/imports/merch",
      onClick: "",
      submenu: false,
      service: SERVICES.Modele
    },
    {
      label: "Modèles",
      icon: "import",
      id: "modeles",
      component: "",
      path: "/imports/modeles",
      onClick: "",
      submenu: false,
      service: SERVICES.Modele
    },
    {
      label: "Secteurs",
      icon: "import",
      id: "secteurs",
      component: "",
      path: "/imports/secteurs",
      onClick: "",
      submenu: false
    },
    {
      label: "KPIs",
      icon: "import",
      id: "kpis",
      component: "",
      path: "/imports/kpis",
      onClick: "",
      minRole: 1,
      submenu: false
    },
    {
      label: "Actions",
      icon: "import",
      id: "actions",
      component: "",
      path: "/imports/actions",
      onClick: "",
      minRole: roles.MANAGER,
      submenu: false
    },
    {
      label: "IOCs",
      icon: "import",
      id: "iocs",
      component: "",
      path: "/imports/iocs",
      onClick: "",
      minRole: 1,
      submenu: false
    },
    {
      label: "Networks",
      icon: "import",
      id: "networks",
      component: "",
      path: "/imports/networks",
      onClick: "",
      minRole: 1,
      submenu: false
    },
    {
      label: "Clients",
      icon: "import",
      id: "clients",
      component: "",
      path: "/imports/clients",
      onClick: "",
      minRole: 1,
      submenu: false
    },
    {
      label: "Typologies",
      icon: "import",
      id: "typologies",
      component: "",
      path: "/imports/typologies",
      onClick: "",
      minRole: 1,
      submenu: false
    },
    {
      label: "Propriétés",
      icon: "import",
      id: "properties",
      component: "",
      path: "/imports/properties",
      onClick: "",
      minRole: 1,
      submenu: false
    },
    {
      label: "Périodes commerciales",
      icon: "import",
      id: "commercial",
      component: "",
      path: "/imports/commercial_periods",
      onClick: "",
      minRole: 3,
      submenu: false
    }
  ]
};



// WEBPACK FOOTER //
// src/pages/imports/Menu.js